import { render, staticRenderFns } from "./buyNowConfirmation.vue?vue&type=template&id=16613cdd&scoped=true"
import script from "./buyNowConfirmation.vue?vue&type=script&lang=js"
export * from "./buyNowConfirmation.vue?vue&type=script&lang=js"
import style0 from "./buyNowConfirmation.vue?vue&type=style&index=0&id=16613cdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16613cdd",
  null
  
)

export default component.exports